import React, { Component } from 'react';
import firebase from "firebase/app";
import 'firebase/firestore';
import "firebase/auth";
import StyleFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import Button from '@material-ui/core/Button';
import * as DbUtils from '../../../common/DbSvc';
import * as Utils from '../../../common/utilSvc';
import { isNullOrUndefined } from "util";
import './JoinMeeting.css';

class JoinMeetingComponent extends React.Component {

    constructor(props){
    
        //Probs
        super(props);

        this.state = {
            meetingId: null,
            isAllowed: false,
            userId: null,
            meeting: null
        }

        if(!isNullOrUndefined(props.match.params.meetingId)){
            this.state.meetingId = JSON.parse(JSON.stringify(props.match.params.meetingId));
        }

        this.addMeetingToUser = this.addMeetingToUser.bind(this);
        this.getUiConfig = this.getUiConfig.bind(this);
        this.resetToLoginPage = this.resetToLoginPage.bind(this);
        this.shouldRender = this.shouldRender.bind(this);
    }

    getUiConfig(){
        let uiConfig = {
            signInFlow: "popup",
            credentialHelper: 'none',
            signInOptions: [
                {
                    provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                    defaultCountry: 'IN'                
                }            
            ],
            callbacks:{
              signInSuccess: () => false,
              signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                
                //...
              }      
            }
          }

        if(window.innerWidth > 768){
            uiConfig.signInOptions.push(firebase.auth.GoogleAuthProvider.PROVIDER_ID);
            uiConfig.signInOptions.push(firebase.auth.EmailAuthProvider.PROVIDER_ID);
        }
        return uiConfig;
    }

    shouldRender(){
        if(this.state.isAllowed && !isNullOrUndefined(this.state.meetingId)){            
            return true;
        }
        return false;
    }

    addMeetingToUser(){
        let meeting = this.state.meeting;
        let permit = 'admin';
        let userId = this.state.userId;
        if(!isNullOrUndefined(meeting) && !isNullOrUndefined(userId) && userId.trim()!=''){
            DbUtils.setUserToMeeting(userId, permit, meeting);
        }
    }

    resetToLoginPage(){
        window.location.href = "/";
    }

    async componentDidMount(){
        
        let scope = this;
        let doc = await firebase.firestore().collection("Meetings").doc(this.state.meetingId).get();

        if(!isNullOrUndefined(doc) && doc.exists){
            //Later on check if joining is allowed
            let meetingData = doc.data();
            scope.setState({
                isAllowed: true,
                meeting: meetingData
            });
        }

        firebase.auth().onAuthStateChanged(user =>{
            var uId = '', providerId = '';
            
            if(!isNullOrUndefined(firebase.auth().currentUser) && 
            !isNullOrUndefined(firebase.auth().currentUser.providerData) &&
            firebase.auth().currentUser.providerData.length>0){
                providerId = firebase.auth().currentUser.providerData[0].providerId;
            }
            if(providerId=="phone"){
                uId = firebase.auth().currentUser.phoneNumber;
            }
            else if(providerId=='google.com'){
                uId = firebase.auth().currentUser.email;
            }
            else if(providerId=='password'){
                uId = firebase.auth().currentUser.email;
            }

            this.setState({
                userId: uId
            });

        // console.log(firebase.auth().currentUser);

            if(!!user){               
               // this.postSignIn();  (Add meeting here)
               this.addMeetingToUser();
            }
        });
        
    }

    render(){
        return (
            <div>
                {this.shouldRender()?
                    <div>
                        <h3>Join meeting</h3>
                        {!isNullOrUndefined(this.state.meeting)?
                            <p>
                                Company: {this.state.meeting.company}
                                <br/><br/>
                                Attendees: {Utils.getMeetingAttendeesString(this.state.meeting.attendees)} 
                                <br/><br/>
                                {!isNullOrUndefined(this.state.userId) && this.state.userId.trim()!=''?
                                    <Button 
                                    color="primary"
                                    variant="contained" 
                                    onClick={this.resetToLoginPage}>
                                        Login as {this.state.userId}
                                    </Button>
                                    :
                                    null
                                }                                             
                            </p>
                            :
                            null
                        }
                        {!(!isNullOrUndefined(this.state.userId) && this.state.userId.trim()!='')?                         
                            <div>
                                Login
                                <StyleFirebaseAuth
                                uiConfig={this.getUiConfig()}
                                firebaseAuth={firebase.auth()}                            
                                />
                            </div>                            
                            :
                            null
                        }
                    </div>
                    :
                    <div>
                        <h3>Not allowed to join</h3>
                    </div>
                }
            </div>
        )
    }
}
export default JoinMeetingComponent;